import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    postRes: null,
    getRes: null,
    getByIdRes: null,
    putRes: null,
    deleteRes: null,
};

const slice = createSlice({
    name: 'labTestPanel',
    initialState,
    reducers: {
        postLabTestPanelRequest: (state) => {
            state.loading = true;
        },
        postLabTestPanelSuccess: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        postLabTestPanelFailure: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        resetPostLabTestPanel: (state) => {
            state.postRes = null;
        },

        getLabTestPanelRequest: (state) => {
            state.loading = true;
        },
        getLabTestPanelSuccess: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        getLabTestPanelFailure: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        resetGetLabTestPanel: (state) => {
            state.getRes = null;
        },

        getLabTestPanelByIdRequest: (state) => {
            state.loading = true;
        },
        getLabTestPanelByIdSuccess: (state, action) => {
            state.loading = false;
            state.getByIdRes = action.payload;
        },
        getLabTestPanelByIdFailure: (state, action) => {
            state.loading = false;
            state.getByIdRes = action.payload;
        },
        resetGetLabTestPanelById: (state) => {
            state.getByIdRes = null;
        },

        putLabTestPanelRequest: (state) => {
            state.loading = true;
        },
        putLabTestPanelSuccess: (state, action) => {
            state.loading = false;
            state.putRes = action.payload;
        },
        putLabTestPanelFailure: (state, action) => {
            state.loading = false;
            state.putRes = action.payload;
        },
        resetPutLabTestPanel: (state) => {
            state.putRes = null;
        },

        deleteLabTestPanelRequest: (state) => {
            state.loading = true;
        },
        deleteLabTestPanelSuccess: (state, action) => {
            state.loading = false;
            state.deleteRes = action.payload;
        },
        deleteLabTestPanelFailure: (state, action) => {
            state.loading = false;
            state.deleteRes = action.payload;
        },
        resetDeleteLabTestPanel: (state) => {
            state.deleteRes = null;
        },
    }
});

export const {
    postLabTestPanelRequest, postLabTestPanelSuccess, postLabTestPanelFailure, resetPostLabTestPanel,
    getLabTestPanelRequest, getLabTestPanelSuccess, getLabTestPanelFailure, resetGetLabTestPanel,
    getLabTestPanelByIdRequest, getLabTestPanelByIdSuccess, getLabTestPanelByIdFailure, resetGetLabTestPanelById,
    putLabTestPanelRequest, putLabTestPanelSuccess, putLabTestPanelFailure, resetPutLabTestPanel,
    deleteLabTestPanelRequest, deleteLabTestPanelSuccess, deleteLabTestPanelFailure, resetDeleteLabTestPanel,
} = slice.actions;

export default slice.reducer;
